// frontend/src/HomePage.js
import React from 'react';
import './HomePage.css'; // Assuming CSS exists

function HomePage({ navigateToExplorer, navigateToChat, navigateToConfig, authUsername, theme }) {
    return (
        <div className="home-page-container">
            <div className="home-page-logo-container">
                <img
                    src={theme === 'LIGHT' 
                        ? `${process.env.PUBLIC_URL}/Pearlify_light_2.PNG` 
                        : `${process.env.PUBLIC_URL}/Pearlify_dark_2.PNG`
                    }
                    alt="Pearlify"
                    className="home-page-logo"
                />
            </div>
            <header className="home-page-header">
                {/* UPDATED App Name */}
                <h1>Welcome to Pearlify, {authUsername}!</h1>
                <p>Your central hub for knowledge exploration and interaction.</p>
            </header>
            <nav className="home-navigation">
                <h2>Choose Your Tool:</h2>
                <div className="nav-options">
                    <button onClick={navigateToExplorer} className="nav-option-button explorer">
                        <div className="nav-option-icon">🧭</div>
                        <h3>Knowledge Explorer</h3>
                        <p>Visually explore connected concepts and research findings.</p>
                    </button>
                    <button onClick={navigateToChat} className="nav-option-button chat">
                         <div className="nav-option-icon">💬</div>
                        <h3>Intelligent Chat</h3>
                        <p>Engage in conversations using various AI models and tools.</p>
                    </button>
                    <button onClick={navigateToConfig} className="nav-option-button config">
                        <div className="nav-option-icon">⚙️</div>
                        <h3>Configuration</h3>
                        <p>Manage data sources, prompts, pipelines, and settings.</p>
                    </button>
                </div>
            </nav>
            <footer className="home-page-footer">
                <p>Select an option above to begin.</p>
            </footer>
        </div>
    );
}

export default HomePage;